<template>
  <div class="custom bg-[#23242A]">
      <div class="flex xl:flex-row flex-col px-4 pt-4 bg-[#23242A] text-white">
          <div class="transition-all duration-100 ease-linear custom-left mr-2 w-full">
              <PurchaseOrderViewList :split="false" />
          </div>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent} from "vue";
import PurchaseOrderViewList from '@/views/Products/PurchaseOrder/PurchaseOrderView/List.vue'

export default defineComponent({
    components: {
      PurchaseOrderViewList,
    },
  })
</script>